import BaseCan from "./baseCan";
import User from "../models/user";
import {OrganizationRoleCapability} from "~/enums/roles/capabilities/organizationRoleCapability";
import UserDecorator from "../../formability/admin/models/userDecorator";
import ListView from "../models/listViews/listView";
import { DocumentRoleCapability } from "~/enums/roles/capabilities/documentRoleCapability";
import PublishedListView from "~/models/listViews/publishedListView";
import ObjectModelAction from "~/models/objectModelActions/objectModelAction";
import {PeerDocumentRoleCapability} from "~/enums/roles/capabilities/peerDocumentRoleCapability";

export default class ListViewCan extends BaseCan {
  constructor(user: User | UserDecorator) {
    // List view abilities based on object model abilities as of now
    super(user);

    const listViewClasses = [ListView, PublishedListView];


    this.iCan(['viewContextMenu'], listViewClasses, listView => {
      if (listView.isArchive) return false;

      return user.hasOrganizationCapability(OrganizationRoleCapability.manageObjectModels) ||
             listView.hasShareCapability(user, DocumentRoleCapability.editModeling);
    })

    this.iCan(['manage', 'edit', 'moveArchive', 'clone'], listViewClasses, _listView => {
      return user.hasOrganizationCapability(OrganizationRoleCapability.manageObjectModels);
    });

    this.iCan(['edit'], listViewClasses, listView => {
      return listView.hasShareCapability(user, DocumentRoleCapability.editModeling);
    });

    this.iCan(['exportCSV'], listViewClasses , listView => {
      return listView.folder.hasShareCapability(user, DocumentRoleCapability.exportObjectModelRecordData) ||
        user.hasOrganizationCapability(OrganizationRoleCapability.manageObjectModels) ||
        listView.hasShareCapability(user, PeerDocumentRoleCapability.exportObjectModelRecordData);
    })

    this.iCan(['createInstance'], listViewClasses, (listView: PublishedListView, {action}: { action: ObjectModelAction }) => {
      return listView.allow_create_instances &&
        listView.available_action_client_ids?.includes(action.client_id);
    })

    this.iCan("enableMainAction", listViewClasses, (listView: PublishedListView, {action}: { action: ObjectModelAction }) => {
      return listView.viewers_can_take_main_actions &&
        listView.available_action_client_ids?.includes(action.client_id);
    })
  }
}